import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { VouchersLayout } from '@/features/vouchers/components/vouchers-layout'

const vouchersSearchSchema = z.object({
  voucherTypeId: z.string().optional(),
})

export type VouchersSearch = z.infer<typeof vouchersSearchSchema>

export const Route = createFileRoute('/_authenticated/vouchers')({
  component: VouchersLayout,
  validateSearch: vouchersSearchSchema,
})
